export const GenerateNumber = (length) => {
    if (length <= 0) return "Length should be greater than 0";
    const min = Math.pow(10, length - 1);
    const max = Math.pow(10, length) - 1;
    const randomNumber = Math.floor(min + Math.random() * (max - min + 1));
    return randomNumber;
  };